import ApplicationsIcon from "./applications-icon";
export default ApplicationsIcon;